import $ from 'jquery'
export default {
  name: 'modal-edit-user-examens',
  components: {},
  props: ['user'],
  data () {
    return {
      my_examens: [],
      loading: false

    }
  },
  computed: {
    examens(){
      return this.$store.getters["examens"]
    }
  },
  created(){
    this.$store.dispatch('getExamensMiniInfo')
  },
  mounted () {

  },
  methods: {
    saveExamens(){
      let examIds = []
      this.loading = true 
      this.user.examens.forEach(element => {
        examIds.push(element.id)
      });

      let data = {examensIds: examIds}

      this.$store.dispatch("assignExamensToUsers",{user_id: this.user.id, data: data}).then(
        () =>{
          $('.modal').modal('hide')
          this.loading = false
        }
      )


    }
  }
}


